// extracted by mini-css-extract-plugin
export default {"error":"error--j94uL","container":"container--KcsF_","icon":"icon--hzGu0"};